import { AxiosResponse } from 'axios';
import { HttpResponseList } from 'shell/models/http-response';
import { TypeDestination } from 'shell/models/type-destination';
import { TypeDestinationClient } from '../list/types';

export interface DestinationResponse {
  pageInfo:
    | {
        totalCount: number;
        page: number;
        pageSize: number;
      }
    | undefined;
  typeDestinations: Array<TypeDestinationClient>;
}

export const transformerTypeDestinations = (
  response: AxiosResponse<HttpResponseList<TypeDestination>>
): DestinationResponse => {
  const data = response.data.payload?.list || [];
  const pageInfo = response.data.payload?.pageInfo;

  if (pageInfo) {
    pageInfo.page = pageInfo.page / pageInfo.pageSize;
  }

  return {
    pageInfo,
    typeDestinations: data.map((typeDestination: TypeDestination) => ({
      id: typeDestination?.codice,
      code: typeDestination?.codice.toString(),
      description: typeDestination?.descrizione,
      queueName: typeDestination?.nomeCoda,
    })),
  };
};
